const samlDisclaimerViewTemplate = `
<div>
  <div class="modal-body margin-top-100">
    <h4 class="modal-title"></h4>
    <br>
    <p ng-if="factoryname !== 'BPS'" style="font-size:14px">Your account details will launch in a new window. Click
      Continue to view.</p>
    <span ng-if="factoryname === 'BPS'">
      <span>{{ 'accountList.accountOverview.externalSSODesclaimer1' | translate }}</span>
      <em>{{ 'accountList.accountOverview.externalSSODesclaimer2' | translate }}</em>
      <span>{{ 'accountList.accountOverview.externalSSODesclaimer3' | translate }}</span>
    </span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-link ng-binding" data-dismiss="modal" ng-click="dismiss()">Cancel</button>
    <button class="btn btn-primary pull-right" ng-click="continueClick()">Continue</button>
    <div class="hide">
      <form id="SAMLFORM" method="post" target="_blank">
        <textarea type="hidden" id="SAMLResponse" name="SAMLResponse"></textarea>
      </form>
    </div>
  </div>
</div>
`;
export default samlDisclaimerViewTemplate;
